import React from 'react';
import { Send, CheckCircle2 } from 'lucide-react';
import gsap from 'gsap';
import './Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = React.useState('');
  const [isSubscribed, setIsSubscribed] = React.useState(false);
  const successRef = React.useRef(null);
  const cardRef = React.useRef(null);

  React.useEffect(() => {
    // Entrance animation removed for debugging visibility
  }, []);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      // Wait for re-render then animate
      setTimeout(() => {
        if (successRef.current) {
          gsap.fromTo(successRef.current, 
            { opacity: 0, scale: 0.9, y: 20 }, 
            { opacity: 1, scale: 1, y: 0, duration: 0.6, ease: 'back.out(1.7)' }
          );
        }
      }, 0);
      
      // Auto-hide after 2 seconds
      setTimeout(() => {
        setIsSubscribed(false);
        setEmail('');
      }, 2000);
    }
  };

  return (
    <section className="global-newsletter">
      <div className="newsletter-inner">
        <div className="newsletter-luxury-card" ref={cardRef}>
          <div className="newsletter-blur-bg"></div>
          
          {!isSubscribed ? (
            <div className="newsletter-content-grid">
              <div className="newsletter-text">
                <span className="newsletter-tag">Exclusive Access</span>
                <h2>JOIN THE <span className="gold-text">INNER CIRCLE</span></h2>
                <p>Subscribe to receive early access to new collections, secret sales, and artisanal fragrance tips.</p>
              </div>
              
              <form className="newsletter-premium-form" onSubmit={handleSubscribe}>
                <div className="premium-input-wrap">
                  <input 
                    type="email" 
                    placeholder="YOUR EMAIL ADDRESS" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="newsletter-submit-btn">
                    <span>SUBSCRIBE</span>
                    <Send size={18} />
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <div className="news-success-content" ref={successRef}>
              <CheckCircle2 size={60} className="success-icon" />
              <h3>WELCOME TO THE ELITE</h3>
              <p>Your journey into olfactory excellence has begun. Watch your inbox.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
